export enum PageName {
  RADAR = 'radar',
  TABLE = 'table',
  PROFILE = 'profile',
  ADMIN = 'admin',
  ANALYTICS = 'analytics',
  DASHBOARD = 'dashboard',
  UNSUPPORTED_BROWSER = 'unsupported'
}
